module.exports = __webpack_public_path__ + "static/unboxx-f489dd1bdf317f3f9ec66d18e46a42d5.png";